import { m } from '~/paraglide/messages'

/**
 * Full-page state for when the initial reads failed — real data never
 * arrived, so showing the page would present zeros as truth.
 */
export function LoadError(props: { onRetry: () => void }) {
  return (
    <div class="flex min-h-[70vh] flex-col items-center justify-center gap-2 px-[30px] text-center">
      <h2 class="text-lg font-semibold leading-[26px] text-[#333]">
        {m.dialog_connection_issue_title()}
      </h2>
      <p class="text-base leading-[22px] text-[#666]">
        {m.dialog_connection_issue_description()}
      </p>
      <button
        type="button"
        onClick={() => props.onRetry()}
        class="mt-4 flex h-[52px] items-center justify-center rounded-full bg-cta px-10 text-base font-bold leading-5 text-white shadow-[0_0_20px_-2px_rgba(198,255,205,0.15)]"
      >
        {m.retry()}
      </button>
    </div>
  )
}
